import { createRouter, createWebHistory } from 'vue-router';
import { getSiteTitle } from '@/helpers/router';
import { useUIStore } from '@itx-data/ui-helpers';

export * from './routes';

const router = createRouter({
  history: createWebHistory(''),
  routes: [],
  scrollBehavior: (to, from, savedPosition) => {
    return { left: 0, top: 0 };
  }
});

router.beforeEach((to, from, next) => {
  let title = (to.meta && to.meta.title) || getSiteTitle(to) || import.meta.env.VITE_APP_TITLE;
  const uiStore = useUIStore();

  uiStore.pageTitle = title;
  uiStore.showAppsMenu = (to.meta && (to.meta.showAppsMenu as boolean)) ?? true;

  const nearestWithTitle = to.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.title);

  if (nearestWithTitle) {
    title = `${nearestWithTitle.meta.title}`;
  }

  document.title = title;

  next();
});

export default router;
